/**
 * ajaxnav.js
 *
 * @description Simple jQuery based AJAX controller requestor and markup-output processor.
 * @author Deviate Ltd <http://www.deviate.net.nz>
 * @package silverstripe-ajaxnav
 * @todo Ensure .js is minified
 * @todo Needs to work on load when user is on a page with pre-expanded menu - configurable.
 */

;(function ($) {
  "use strict";

  /**
   *
   * Module JS configuration.
   */
  var config = {
    "ajaxnav_bindto": "ajaxnav-parent-id",              // A data attribute containing an id to send via AJAX
    "ajaxnav_root_id": "#primary-nav",                  // Usually the root <nav> element
    "ajaxnav_controller": "ajaxnav",                    // The name of the controller named in YML config
    "ajaxnav_spinner_class": "spinner",                 // A CSS selector of the spinner to use
    "ajaxnav_click_reciever": "li.parent .nav-ajax-toggle", // A CSS selector of the element that receives the click / touch events
    "reciever_class": "nav-ajax-toggle",
    "ajaxnav_toggle_class": "sub-nav-open"                      // A CSS selector of the clicked-item's nearest <li> tag
  };

  /**
   *
   * Listens to the appropriate DOM nodes and involes behjaviour on each
   * as appropriate e.g. to show/hide the given toggle CSS class or to attach
   * child nodes via AJAX on request.
   *
   * @returns {void}
   */
  var ajaxNavListener = function () {
    /**
     * Onload we no longer have the AJAXed-in navigation markup. To load them
     * at this point would defeat the module's intents. Instead we show the correct
     * CSS toggle class, indicating that there should be child-nodes and clicking
     * this node will re-fetch and display them.
     */
    $(config.ajaxnav_click_reciever).each(function (i, e) {
      var $node = $(e),
        $parentNode = $node.closest('li'),
        parentHasId = typeof $parentNode.data(config.ajaxnav_bindto) != 'undefined',
        parentHasChildren = $parentNode.children('ul').length > 0;

      // Otherwise clicking is the other interaction method
      if (parentHasId && !parentHasChildren) {
        $parentNode.removeClass(config.ajaxnav_toggle_class);
      }
    });
    // All nodes with the data-attr will listen for click & touch events
    $(config.ajaxnav_root_id).on('click', config.ajaxnav_click_reciever, function (e) {
      ajaxNavActioner(e);
    });

    // This is needed to ensure for UA's when resizing, that behaviours aren't continuousely
    // (Re-) added.
    $(window).off('resize.ajaxnav');
  };

  /**
   *
   * This performs the main bulk of the module's JS behaviour.
   *
   * @param {Object} e
   * @returns {Void}
   */
  var ajaxNavActioner = function (e) {
    e.preventDefault();

    var $node = $(e.target),
      $parentNode = $node.closest('li'),
      parentHasId = typeof $parentNode.data(config.ajaxnav_bindto) != 'undefined',
      parentHasChildren = $parentNode.children('ul').length > 0;
    // Allows us _not_ to have to re-call AJAX unnecessarily
    if (!parentHasId || parentHasChildren) {
      if (parentHasChildren) {
        $parentNode.toggleClass(config.ajaxnav_toggle_class);
        if ($parentNode.hasClass(config.ajaxnav_toggle_class)) {
          $(e.target).attr('aria-expanded', 'true').addClass('is-expanded');
          $parentNode.children('ul').attr('aria-expanded', 'true').show();
        } else {
          $(e.target).attr('aria-expanded', 'false').removeClass('is-expanded');
          $parentNode.find('li').removeClass(config.ajaxnav_toggle_class);
          $parentNode.find('ul').attr('aria-expanded', 'false').hide();
        }
      }
      return;
    }

    // Then append
    var parentID = $parentNode.data(config.ajaxnav_bindto),
      controller = '/' + config.ajaxnav_controller + '/' + parentID;

    navSpinner('add', parentID);

    $.post(controller, parentID, function (response, status, jqXHR) {
      var isOk = (status === 'success' && response.length);
      if (isOk) {
        attachSubMenu(response, parentID);
        navSpinner('remove', parentID);
      }
    }, 'html');
  }

  /**
   *
   * Converts the raw markup returned by the controller into a jQuery object,
   * then ensures ensures the correct class is used and attaches the lot to the correct
   * navigation node.
   *
   * @param {XHRHTTPResponse}
   * @param {Int} parentID
   * @returns {Void}
   */
  var attachSubMenu = function (response, parentID) {
    var selector = '[data-' + config.ajaxnav_bindto + '=' + parentID + ']',
      res = $(response);
    $(selector).append(res);
    $(selector).find('.js-nav-item-toggle').attr('aria-expanded', 'true').addClass('is-expanded');
    $(selector).children('ul').attr('aria-expanded', 'true').show();
    if (!$(selector).hasClass(config.ajaxnav_toggle_class)) {
      $(selector).addClass(config.ajaxnav_toggle_class);
    }
  };

  /**
   *
   * Add or remove a spinner animation to the selected navigation menu
   * item.
   *
   * @returns {Void}
   */
  var navSpinner = function (action, parentID) {
    var selector = '[data-' + config.ajaxnav_bindto + '=' + parentID + ']';
    if (action === 'add') {
      if (!$(selector).hasClass(config.ajaxnav_toggle_class)) {
        $(selector).addClass(config.ajaxnav_toggle_class);
      }
      $(selector).append(
        $('<ul class="loading nav-item__submenu"><li class="nav-item nav-item--loading"><div class="nav-item__main">Loading...</div></li></ul>')
          .attr('aria-expanded', 'true')
          .show()
      );
      //$(selector).find('>span>button').addClass(config.ajaxnav_spinner_class);
    } else {
      $(selector).find('ul.loading').remove();
      //$('.' + config.ajaxnav_spinner_class).removeClass(config.ajaxnav_spinner_class);
    }
  }

  /**
   *
   * Start listening on DOM-ready
   */
  $(document).ready(function () {
    ajaxNavListener();
  });

  /**
   *
   * Start listening on Window-resize
   */
  $(window).on('resize.ajaxnav', function () {
    ajaxNavListener();
  });

})(jQuery);
